import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import Wizard from "../../components/Wizard";
import { usePageContent } from "../../hooks/usePageContent";
import "./index.module.css";

const RestyleSuccessPage = () => {
  const navigate = useNavigate();
  const { find } = usePageContent('restyle-success');
  const wizardContent = find('wizard')         || {};
  const c             = find('successMessage') || {};
  const wizardSteps = wizardContent.steps || [
    { title: 'Check combination' },
    { title: 'Select a style' },
    { title: 'Confirm ownership' },
    { title: 'Checkout' },
  ];

  const [orderData, setOrderData] = useState(null);
  const [orderNumber, setOrderNumber] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedOrderData = sessionStorage.getItem("plateOrderData");
    if (!storedOrderData) {
      navigate("/");
    } else {
      setOrderData(JSON.parse(storedOrderData));
      setOrderNumber(sessionStorage.getItem("orderNumber") || "");
      sessionStorage.removeItem("plateOrderData");
      sessionStorage.removeItem("orderNumber");
      setLoading(false);
    }
  }, [navigate]);

  const getPlateImages = () => {
    if (!orderData) return [];

    if (orderData.plateImages?.isOOE) {
      const images = [];
      if (orderData.plateImages.standard) images.push({ src: orderData.plateImages.standard, label: "Standard" });
      if (orderData.plateImages.slimline) images.push({ src: orderData.plateImages.slimline, label: "Slimline" });
      return images;
    }

    const single = orderData.plateImages?.single || orderData.plateImages?.standard || orderData.plateImages?.slimline || "";
    return single ? [{ src: single }, { src: single }] : [];
  };

  if (loading || !orderData) {
    return (
      <div id="content">
        <div className="row">
          <div className="plate-wizard">
            <div className="loading__panel" role="alert">{c.loadingText || 'Loading...'}</div>
          </div>
        </div>
      </div>
    );
  }

  const plateImages = getPlateImages();

  return (
    <div id="content">
      <div className="row">
        <div className="page-header">
          <div className="page-header__content">
            <h1 className="page-header__title">{c.pageTitle || 'Restyle a plate'}</h1>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="plate-wizard">
          <Wizard
            steps={wizardSteps}
            currentStep={4}
          />

          <div className="plate-wizard__form plate-wizard__form--success">
            <div className="plate-wizard__form-header">
              <h2 className="plate-wizard__form-title" tabIndex="-1" style={{ textAlign: "center" }}>{c.sectionTitle || 'Payment successful'}</h2>
            </div>

            <div>
              <div className="success-message">
                <div className="success-message__inner">

                  <h3 className="success-message__title">{c.orderConfirmationLabel || 'Your Order Confirmation Id:'} {orderNumber}</h3>

                  <div className="rich-text">
                    <p>{c.thankYouText || "Thanks for your plate order! You'll receive a confirmation email from us soon which will explain what happens next and when your plates will arrive."}</p>
                    <p>{c.emailSupportText || "If you don't receive a confirmation email within 24 hours, please check your junk mail or contact"} <a href={`mailto:${c.emailSupportAddress || 'custom.plates@roads.vic.gov.au'}`}>{c.emailSupportAddress || 'custom.plates@roads.vic.gov.au'}</a> or {c.emailSupportPhone || '1300 660 417'} ({c.emailSupportHours || 'between 8:30am - 5:00pm on Monday to Friday'}).</p>
                  </div>

                  {plateImages.length > 0 && (
                    <div className="success-message__image-holder">
                      {plateImages.map((image, index) => (
                        <img
                          key={index}
                          className="success-message__image"
                          src={image.src}
                          alt={c.plateImageAlt || 'Preview image of your plate'}
                        />
                      ))}
                    </div>
                  )}

                  <p className="success-message__disclaimer">
                    {c.disclaimer || 'Representation of plates provided are for illustrative purposes only. Final products may vary from what is displayed.'}
                  </p>

                  <div className="success-message__actions">
                    <Link to="/" className="button button--full-width">
                      <span className="button__text">{c.createNewPlateText || 'Create a new plate'}</span>
                    </Link>
                    <Link to="/browse-styles" className="button button--full-width button--secondary">
                      <span className="button__text">{c.browseStylesText || 'Browse plate styles'}</span>
                    </Link>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestyleSuccessPage;
